export interface CastawayBio {
  name: string;
  aliases?: string[];
  age: number;
  occupation: string;
  currentResidence?: string;
  hometown?: string;
  bioQuotes: string[];
  highlights?: string;
  imageUrl?: string;
  sourceUrl?: string;
}

export const SEASON_51_CASTAWAY_BIOS: Record<string, CastawayBio> = {
  "aaliyah puglia": {
    name: "Aaliyah Puglia",
    age: 24,
    occupation: "Chef",
    currentResidence: "Providence, R.I.",
    hometown: "Gloucester City, N.J.",
    bioQuotes: [
      "I’m a bold, independent woman who was raised by bold independent women.",
      "I’m not here to find myself. I’m here to win the title and come back with something that my family can be proud of.",
      "I'm adaptable and plan on building loyalty and leading with kindness, especially in the beginning."
    ],
    highlights: "24-year-old chef raised by bold women, focusing on adaptable gameplay and building early loyalty through kindness.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "alexis levine": {
    name: "Alexis Levine",
    age: 34,
    occupation: "Criminal Defense Attorney",
    currentResidence: "Atlanta, Ga.",
    bioQuotes: [
      "All I care about is my family and our future.",
      "My friends and family would describe me as a social butterfly and maybe at times a chameleon."
    ],
    highlights: "34-year-old mother of one and criminal defense attorney who plans to conceal her law profession by posing as a treatment care coordinator.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "an “thien an” nguyen": {
    name: "An “Thien An” Nguyen",
    aliases: ["an nguyen", "thien an nguyen", "thien an", "an \"thien an\" nguyen"],
    age: 24,
    occupation: "Medical Student",
    currentResidence: "Fort Worth, Texas",
    bioQuotes: [
      "Being small and having a big smile on my face helps people open up to me. How I navigate through life is just making genuine connections.",
      "I can be freaking weird, but I'm entering Fiji with a YOLO mentality.",
      "I'm a very competitive person who hates losing, ready to play the most authentic, cut-throat game possible."
    ],
    highlights: "24-year-old medical student bringing big smiles and a cut-throat competitive edge.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "ana sani": {
    name: "Ana Sani",
    age: 34,
    occupation: "Voice Actress / Actress",
    currentResidence: "Toronto, Ontario, Canada",
    bioQuotes: [
      "I’m going to win Survivor, because I’m not afraid to take risks, play a little deviously and no one’s going to see it coming, because I’m cutesy.",
      "I'm eager to get out there and trick people."
    ],
    highlights: "Voice actress known for My Little Pony, Strawberry Shortcake, and Prime Video's The Boys, leaning into her charming demeanor to execute devious blindsides.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "angelica “jelly” loblack": {
    name: "Angelica “Jelly” Loblack",
    aliases: ["angelica loblack", "jelly loblack", "angelica \"jelly\" loblack", "jelly"],
    age: 29,
    occupation: "Sociology Professor",
    currentResidence: "Bloomington, Ind.",
    bioQuotes: [
      "I want to be confronted with my biggest weaknesses, so I can grow from them. I just know that I’ll leave here a completely different person for the better.",
      "Even though I'm not outdoorsy, I'm curious, talkative, spontaneous and fun."
    ],
    highlights: "29-year-old sociology professor planning to analyze interpersonal dynamics and social structures to get ahead.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "brady booker": {
    name: "Brady Booker",
    age: 27,
    occupation: "Professional Wrestler",
    bioQuotes: [
      "I want people to think I'm a big dumb jock, when in reality I have three college degrees and am prepared to outwit everyone.",
      "Grew up fishing, hunting, hiking and everything in between."
    ],
    highlights: "27-year-old pro wrestler and outdoor enthusiast armed with three college degrees, hiding his intellect behind a jock persona.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "carter krull": {
    name: "Carter Krull",
    age: 24,
    occupation: "Livestock Farmer & Entrepreneur",
    currentResidence: "Sioux Falls, S.D.",
    bioQuotes: [
      "I love to stay busy, I love getting my hands dirty."
    ],
    highlights: "24-year-old hardworking livestock farmer, entrepreneur, and photography enthusiast ready for camp life grit.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "cristian chavez": {
    name: "Cristian Chavez",
    age: 26,
    occupation: "Head of HR",
    currentResidence: "Salt Lake City, Utah",
    bioQuotes: [
      "I love competition. If I’m not winning, I’m going to make sure somebody else loses.",
      "I'm a bubbly and eccentric person who gives off little brother energy."
    ],
    highlights: "26-year-old Head of HR who started college at age 15, pairing high energy with ruthless competitiveness.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "danny “kilby” kilby": {
    name: "Danny “Kilby” Kilby",
    aliases: ["danny kilby", "kilby kilby", "danny \"kilby\" kilby", "kilby"],
    age: 30,
    occupation: "Game Designer",
    currentResidence: "London, Ontario, Canada",
    bioQuotes: [
      "I am a hustler through and through. You have to stand out or you’re cooked.",
      "A self-described Survivor dork who has participated in various fan conventions."
    ],
    highlights: "30-year-old video game designer and superfan whose life revolves around analyzing games and rulebooks.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "devin way": {
    name: "Devin Way",
    age: 33,
    occupation: "Actor",
    hometown: "Lufkin, Texas",
    bioQuotes: [
      "I really love people, and I really love games, and I can spin anything on its head to make it a positive.",
      "Keeping my acting profession strictly to myself and focusing on my small-town upbringing."
    ],
    highlights: "33-year-old actor (Grey’s Anatomy, Queer as Folk, Station 19) keeping his career under wraps to build genuine, charming social bonds.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "eric macksoud": {
    name: "Eric Macksoud",
    age: 34,
    occupation: "Mental Health Counselor",
    currentResidence: "Windsor Locks, Conn.",
    bioQuotes: [
      "My intentions are good, overall. I want to make friends with these people. However, if any of them cross me, that’s when the fangs are going to come out."
    ],
    highlights: "34-year-old mental health counselor aiming to balance empathy with cutthroat tactical responses when crossed.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "jenna doore": {
    name: "Jenna Doore",
    age: 30,
    occupation: "Wedding Photographer",
    bioQuotes: [
      "I think I’ll be good at connecting with people, and I think they might underestimate me as a cutie little artist adorable girl. I hope they do, because I have been preparing for this like it’s my destiny.",
      "Energetic, empathetic and determined."
    ],
    highlights: "30-year-old wedding photographer viewing Survivor as her lifelong calling, ready to capitalize on being underestimated.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "kristin flickinger": {
    name: "Kristin Flickinger",
    age: 49,
    occupation: "Crisis Management",
    currentResidence: "Santa Barbara, Calif.",
    hometown: "Idaho",
    bioQuotes: [
      "This is an adventure of a lifetime, it is this journey of self exploration, it is a social experiment, it is a community.",
      "Friends describe her as agitating but also lovely."
    ],
    highlights: "49-year-old crisis management professional and the season's oldest castaway, accustomed to navigating high-stakes situations.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "lewis kelly": {
    name: "Lewis Kelly",
    age: 28,
    occupation: "Farmer",
    currentResidence: "Puerto Rico (living in a converted school bus)",
    hometown: "Ireland",
    bioQuotes: [
      "Sometimes I do like to push a button or two. Sometimes I like to get in on the bit of drama that’s going on.",
      "Chaotic, mischievous, and ready to stir up camp dynamics."
    ],
    highlights: "28-year-old cheeky Irish farmer living in Puerto Rico in a converted school bus, openly embracing camp chaos.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "linnea capobianco": {
    name: "Linnea Capobianco",
    age: 25,
    occupation: "Lingerie & Adult Store Owner",
    hometown: "New Jersey",
    bioQuotes: [
      "I’m here, because I say yes to things even when I’m scared. I say yes to things that are a big challenge or that would make me super uncomfortable.",
      "Outgoing, social, and goofy, but also super logical from a family of scientists."
    ],
    highlights: "25-year-old entrepreneur with a science background, mixing goofy sociability with calculated logic.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "maggie nestor": {
    name: "Maggie Nestor",
    age: 40,
    occupation: "Farmer, Teacher & Hunter",
    currentResidence: "Charlestown, W.Va.",
    bioQuotes: [
      "I am a jack of all trades. I’m athletic. I also have a therapy degree, so I know how to work people, and I’m also a teacher.",
      "Lifetime hunter, fisher, and mother."
    ],
    highlights: "40-year-old farmer and teacher with a background in therapy and lifelong outdoors skills.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "mike pinsky": {
    name: "Mike Pinsky",
    age: 32,
    occupation: "Baseball Executive",
    currentResidence: "New York City, N.Y.",
    bioQuotes: [
      "I am someone who shoots for these seemingly impossible targets. I don’t do anything for second place. I’m here to win the game, period full stop."
    ],
    highlights: "32-year-old NYC baseball front-office executive applying analytics and calculated game theory to win.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "ori jean-charles": {
    name: "Ori Jean-Charles",
    aliases: ["ori-jean charles", "ori jean charles", "ori jeancharles"],
    age: 27,
    occupation: "Personal Trainer & Former Pro Athlete",
    bioQuotes: [
      "I’m book-smart, I’m street-smart, and I’m a former pro athlete so it’s one of those things where I am made for Survivor. I have a fierce competitive fire in me.",
      "A Type A personality who refuses to be pigeonholed as just a physical threat."
    ],
    highlights: "27-year-old former football pro and trainer pairing physical dominance with book smarts.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "patt cannaday": {
    name: "Patt Cannaday",
    age: 33,
    occupation: "Military Federal Prosecutor",
    currentResidence: "Washington, D.C.",
    hometown: "Florida",
    bioQuotes: [
      "When I’m in an alliance, I want them to feel that closeness with me, but I’m ready to go to war with any of these people.",
      "Pretty nerdy, but an absolute ace in the courtroom."
    ],
    highlights: "33-year-old military federal prosecutor skilled in cross-examination, alliances, and trial strategy.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "rob antonson": {
    name: "Rob Antonson",
    age: 40,
    occupation: "Airline Agent",
    currentResidence: "Cumberland, R.I.",
    bioQuotes: [
      "My secret weapon out here would be the gift of gab. I would love to have friends for life from this experience.",
      "A funny, outgoing, somewhat adventurous guy with many layers — and here for the chaos."
    ],
    highlights: "40-year-old father of three and airline agent wielding the gift of gab and camp humor.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  },
  "sharonda cox": {
    name: "Sharonda Cox",
    age: 34,
    occupation: "OBGYN Resident",
    bioQuotes: [
      "I need to do something for myself. I’ve been going through the motions for so long that I need something new, and I think Survivor really puts you in those places where you cannot hide.",
      "Bringing both tenacity and street smarts into the game."
    ],
    highlights: "34-year-old OBGYN resident playing for herself with deep resilience and clinical poise.",
    sourceUrl: "https://people.com/survivor-season-51-cast-12068979"
  }
};

const normalizeName = (name: string): string => {
  return name.toLowerCase().replace(/["“”'‘’]/g, '"').trim();
};

export const getCastawayBio = (name: string, bioText?: string): CastawayBio | null => {
  if (!name) return null;
  const clean = normalizeName(name);

  // Exact match
  if (SEASON_51_CASTAWAY_BIOS[clean]) {
    return SEASON_51_CASTAWAY_BIOS[clean];
  }

  // Alias or fuzzy matching
  for (const key of Object.keys(SEASON_51_CASTAWAY_BIOS)) {
    const candidate = SEASON_51_CASTAWAY_BIOS[key];
    if (clean === normalizeName(candidate.name)) return candidate;
    if (candidate.aliases?.some(alias => normalizeName(alias) === clean || clean.includes(normalizeName(alias)) || normalizeName(alias).includes(clean))) {
      return candidate;
    }
    // First name + last name matching without quotes
    const strippedCandidate = candidate.name.replace(/["“”'‘’][^"“”'‘’]+["“”'‘’]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
    const strippedTarget = name.replace(/["“”'‘’][^"“”'‘’]+["“”'‘’]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (strippedCandidate && strippedTarget && (strippedCandidate === strippedTarget || strippedCandidate.includes(strippedTarget) || strippedTarget.includes(strippedCandidate))) {
      return candidate;
    }
  }

  // If custom bio is present on castaway object
  if (bioText && bioText.trim()) {
    return {
      name,
      age: 0,
      occupation: '',
      bioQuotes: [bioText.trim()]
    };
  }

  return null;
};
